import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import DataGrid from '../../OurModules/DataGrid/src/index.js';
import moment from 'moment-timezone';
import * as FileSaver from 'file-saver';


class Wellness extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showNaturallySlim: false,
            shouldRetrieveData: true,
            isSWHP: false,
            isSWHPEmployee: false,
            isMedicare: false,
            isAmisys: false
        }
    }

    componentDidMount() {
        this.componentDidUpdate(this.props);
        logUI("MBHWeb.UI.Wellness.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate() {
        const { hpIdentity, swhp, healthPlanNetworkCode } = this.props;

        if ((swhp || hpIdentity) && this.state.shouldRetrieveData) {

            if ((swhp || (hpIdentity && hpIdentity.roles.includes("NaturallySlimSsoUsers")))) {
                this.setState({
                    showNaturallySlim: true
                });
            }
            this.setState({
                shouldRetrieveData: false,
                isSWHPEmployee: swhp && healthPlanNetworkCode.includes("BSWE"),
                isMedicare: (hpIdentity && hpIdentity.roles.includes("MedicareMembers")) || (swhp && (healthPlanNetworkCode.includes("SCA_HMO") || healthPlanNetworkCode.includes("SCA_PPO"))),
                isSWHP: swhp || (hpIdentity && hpIdentity.loginOrganization === "SWHPC") ? true : false,
                isAmisys: swhp

            });
        }
    }

    render() {
        const crazyWidth = { float: 'right', top: '19px', left: '-35px', position: 'relative', 'zIndex': '10' };

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="hp-title">
                            Wellness
                        </div>
                    </div>
                    <hr className="full-width"></hr>
                    <div className="col-12 maxWidth-content">
                        <div className="claim-wrapper">
                            <div className="claim-container">
                                {this.state.isSWHPEmployee || this.state.isMedicare ? ""
                                    :
                                    <div className="row">
                                        <div className="row col-12 bold-text no-gutters wellness-title">
                                            <div className="align-items">
                                                Wellbeing Assessment
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div>
                                                <div>
                                                    The WebMD digital wellness platform encourages members to be healthy, while providing personalized support for various health conditions and health risks. Start with an online health assessment to access recommendations and daily habits to improve your health and well-being. The well-being assessment is a simple digital health survey that helps you take steps towards a healthier and more vibrant life.
                                                </div>
                                                <br />
                                                <div>
                                                    <span className="bold-text">Digital Wellness Coaching</span> - Stay engaged, track progress and accomplish well-being goals by utilizing Daily Habits. Daily Habits offers you a personalized set of activities based on your health information and personal interests.
                                                </div>
                                                <div className="bold-text">
                                                    <ul>
                                                        <li>Nutrition</li>
                                                        <li>Sleep</li>
                                                        <li>Stress</li>
                                                        <li>Physical Activity</li>
                                                        <li>Tobacco</li>
                                                    </ul>
                                                </div>
                                                <div>
                                                    <span className="bold-text">Wellness Challenges</span> - Join a wellness challenge for the motivation to go the extra mile. Wellness Challenges encourage sustainable, healthy habits through competition and accountability. Gamify drinking water, taking the stairs and other activities that challenge and boost your well-being.
                                                </div>
                                                <br />
                                                <div>
                                                    <span className="bold-text">Digital Health Library</span> - articles, videos, recipes and motivational apps to support a healthier life. You can search for condition-specific information or explore other health topics of interest.
                                                </div>
                                                <br />
                                                <div>
                                                    <span className="btn" onClick={() => this.props.ssoFirstCarePlus()}>LEARN MORE</span>
                                                </div>
                                                <hr></hr>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/*
                                    
                                    <hr></hr>
                                <div className="row">
                                    <div className="row col-12 bold-text no-gutters amount-owed-wrapper">
                                        <div className="align-items">
                                            Complex Case Management
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <p>
                                            This program is for members who have chronic conditions or complex care needs.  A nurse case manager will work with members, families, and the physician to create a plan to meet the member's ongoing complex care needs.  Case Managers advocate for members and assist them with setting goals and making a personal plan to improve their health.  They also can assist with arrangements for necessary services.  Case Managers answer questions and provide education to help members have a better understanding of their condition and plan of care.
                                        </p>
                                        <p>
                                            The purpose of the program is to help members get the best possible results and the greatest value from their health plan.  Participation is voluntary.  There is no additional cost to members for this program.
                                        </p>
                                        <p>
                                            For more information, please request a screening to see if Complex Case Management is the right program for your needs.
                                        </p>
                                        <br />
                                        <div>
                                            <span className="btn" onClick={() => alert("need link for complex case management")}>LEARN MORE</span>
                                        </div>
                                    </div>
                                </div>
                                 
                                 */}

                                {this.state.showNaturallySlim ?
                                    <div>
                                        <div className="row">
                                            <div className="row col-12 bold-text no-gutters wellness-title">
                                                <div className="align-items">
                                                    Naturally Slim
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div>
                                                    The Naturally Slim<sup>&reg;</sup> program has the secret to lasting weight loss and it doesn't include starving, counting calories or eating diet food. This simple, online program helps you change how you eat instead of what you eat. Plus, it will help you reduce your chances of getting a serious disease, like diabetes or heart disease, and increase your chance at living a longer, healthier life
                                               </div>
                                                <br />
                                                <div>
                                                    <span className="btn" onClick={() => this.props.ssoNaturallySlim()}>LEARN MORE</span>
                                                </div>
                                            </div>
                                        </div>
                                        <hr></hr>
                                    </div>
                                    :
                                    ""}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        healthPlanNetworkCode: state.domain.nc,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ssoFirstCarePlus: () => dispatch({ type: types.HP_SSO_FIRSTCAREPLUS_START }),
        ssoNaturallySlim: () => dispatch({ type: types.HP_SSO_NATURALLYSLIM_START }),
        ssoPharmacyBenefits: () => dispatch({ type: types.HP_SSO_PHARMACY_START }),
        ssoThrive: () => dispatch({ type: types.HP_SSO_THRIVE_START }),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wellness));